import { DefaultTheme } from 'styled-components';

export type ColorsType = typeof colors;
export type TypographyType = typeof typography;

const colors = {
    // General
    whiteColor: '#FFFFFF',
    blackColor: '#000000',
    grayColor: '#AAAAAA',

    // Point
    activeRed: '#FF0000',
    activeBlue: '#0078FF',
    activeSkyBlue: '#6679FE',
    activeOrange: '#FF5700',
    warningRed: '#FF6464',
    pointGreen: '#4BBB46',

    // Icon
    grayIconColor: '#919191',
    closeIcon: '#CACBD4',

    // Font
    grayFontColor: '#7B7B80',
    lightGrayFontColor: '#B3B3B3',
    sidebarGrayFontColor: '#CFCFCF',
    ultraLightGrayFontColor: '#D1D1D1',
    deepGrayFontColor: '#6E6E6E',

    // Border
    lightGrayBorder: '#E5E5E5',
    ultraLightGrayBorder: '#F3F3F3',
    brightGrayBorderColor: '#E8E8E8',

    // Background
    lightGrayHoverColor: '#F9F9F9'
};
const typography = {
    largeTitle: {
        // Large Title
        fontSize: '28px',
        lineHeight: '36px'
    },
    mediumTitle: {
        // Title 1 (medium title)
        fontSize: '24px',
        lineHeight: '32px'
    },
    headline1: {
        // Headline 1
        fontSize: '20px',
        lineHeight: '28px'
    },
    headline2: {
        // Headline 2
        fontSize: '16px',
        lineHeight: '24px'
    },
    bodyDesktop: {
        // Body Desktop
        fontSize: '18px',
        lineHeight: '26px'
    },
    bodyMobile: {
        // Body Mobile
        fontSize: '14px',
        lineHeight: '22px'
    },
    caption: {
        // Caption
        fontSize: '12px',
        lineHeight: '18px'
    }
};

const theme: DefaultTheme & {
    colors: ColorsType;
    typography: TypographyType;
} = {
    colors,
    typography
};

export default theme;
